const SLIDES_PER_VIEW_FLUID_MOBILE = 1.2;

export const isHiddenElement = ({
  slidesPerView,
  elementIndex,
  visibleSlidesIndexes,
  variant,
  isEnd,
  activeIndex,
}: {
  slidesPerView: number;
  elementIndex: number;
  visibleSlidesIndexes: number[];
  variant: 'fixed' | 'fluid' | 'single';
  isEnd: boolean;
  activeIndex: number;
}): boolean => {
  if (variant === 'fixed') {
    if (slidesPerView >= visibleSlidesIndexes.length) return false;

    if (isEnd) {
      return visibleSlidesIndexes[0] === elementIndex;
    }
    const activeIndexPosition = visibleSlidesIndexes.indexOf(activeIndex);
    const checkArr =
      activeIndexPosition === 0
        ? visibleSlidesIndexes.slice(0, -1)
        : visibleSlidesIndexes.slice(activeIndexPosition);

    return !checkArr.includes(elementIndex);
  }

  if (slidesPerView === SLIDES_PER_VIEW_FLUID_MOBILE) {
    return elementIndex !== activeIndex;
  }

  return false;
};
